<template>
  <rest-page :fetch-endpoint="fetchEndpoint">
    <page-header-new
      :title="$t('Channels_InboxSettings')"
      :breadcrumbs="breadcrumbs"
    />
    <page-content>
      <rest-form
        ref="form"
        :save-endpoint="saveEndpoint"
        :after-save="afterSave"
        :model="model"
        :rules="rules"
        :disabled="false"
      >
        <form-section
          :title="$t('InboxMessageSettingsGlobal_Title')"
          :description="$t('InboxMessageSettingsGlobal_Description')"
        >
          <template slot="controls">
            <save-button :click="save" />
          </template>

          <div>
            <rest-form-item
              prop="inbox_badge"
              :label="$t('InboxMessageSettingsGlobal_Inbox_Badge')"
              :description="$t('InboxMessageSettingsGlobal_Inbox_Badge_Desc')"
            >
              <radio-group v-model="model.inbox_badge">
                <radio
                  :label="0"
                  :title="$t('InboxMessageSettingsGlobal_Disabled')"
                  :description="$t('InboxMessageSettingsGlobal_Disabled_Desc')"
                ></radio>

                <radio
                  :label="1"
                  :title="$t('InboxMessageSettingsGlobal_Inbox_Not_Seen')"
                  :description="
                    $t('InboxMessageSettingsGlobal_Inbox_Not_Seen_Desc')
                  "
                ></radio>

                <radio
                  :label="2"
                  :title="$t('InboxMessageSettingsGlobal_Inbox_Not_Opened')"
                  :description="
                    $t('InboxMessageSettingsGlobal_Inbox_Not_Opened_Desc')
                  "
                ></radio>
              </radio-group>
            </rest-form-item>
          </div>

          <div class="m-top-30">
            <rest-form-item
              prop="inbox_remove"
              :label="$t('InboxMessageSettingsGlobal_Content_Options')"
              :description="
                $t('InboxMessageSettingsGlobal_Content_Options_Desc')
              "
            >
              <template v-slot:label>
                <span>
                  {{ $t('InboxMessageSettingsGlobal_Content_Options') }}
                </span>
                <el-tooltip
                  effect="light"
                  :content="
                    $t('InboxMessageSettingsGlobal_Content_Options_Info')
                  "
                  placement="top"
                >
                  <i class="el-icon-info" />
                </el-tooltip>
              </template>
              <radio-group v-model="model.inbox_remove">
                <radio
                  :label="0"
                  :title="$t('InboxMessageSettingsGlobal_Dont_Remove')"
                ></radio>

                <radio
                  :label="1"
                  :title="$t('InboxMessageSettingsGlobal_Remove_After')"
                ></radio>
              </radio-group>

              <div class="remove-after-inputs">
                <el-input-number
                  :min="1"
                  controls-position="right"
                  v-model="model.inbox_remove_after.count"
                  :disabled="!model.inbox_remove"
                />

                <el-select
                  v-model="model.inbox_remove_after.period"
                  :disabled="!model.inbox_remove"
                >
                  <el-option
                    v-for="(label, value) in periodOptions"
                    :key="value"
                    :value="value"
                    :label="label"
                  />
                </el-select>
              </div>
            </rest-form-item>
          </div>
        </form-section>
      </rest-form>
    </page-content>
  </rest-page>
</template>

<script>
import RestForm from '@/common/components/rest/RestForm'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import RestFormItem from '@/common/components/rest/RestFormItem'
import RestPage from '@/common/components/rest/RestPage'
import FormSection from '@/common/components/form/FormSection'
import RadioGroup from '@/common/components/form/RadioGroup'
import Radio from '@/common/components/form/Radio'
import SaveButton from '@/common/components/form/SaveButton'
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import PageContent from '@/common/components/page/PageContent'

export default {
  name: 'InboxSettingsPage',
  components: {
    PageContent,
    PageHeaderNew,
    SaveButton,
    Radio,
    RadioGroup,
    FormSection,
    RestFormItem,
    RestForm,
    RestPage
  },
  data() {
    return {
      model: {
        inbox_badge: 0,
        inbox_remove: 0,
        inbox_remove_after: {
          count: 0,
          period: 'days'
        }
      },
      periodOptions: {
        seconds: this.$t('InboxMessageSettingsGlobal_Period_Seconds'),
        minutes: this.$t('InboxMessageSettingsGlobal_Period_Minutes'),
        hours: this.$t('InboxMessageSettingsGlobal_Period_Hours'),
        days: this.$t('InboxMessageSettingsGlobal_Period_Days'),
        weeks: this.$t('InboxMessageSettingsGlobal_Period_Weeks')
      }
    }
  },
  props: {
    projectId: {
      required: false
    }
  },
  methods: {
    save() {
      this.$refs['form'].save()
    },
    afterSave(data, finishLoading) {
      finishLoading.apply()
    }
  },
  computed: {
    breadcrumbs() {
      return [
        {
          label: this.$t('Settings_Breadcrumb_Settings')
        },
        {
          label: this.$t('Settings_Breadcrumb_Channels'),
          route: projectRoute({
            name: 'EnableChannelsTab'
          })
        },
        {
          label: this.$t('Channels_InboxSettings')
        }
      ]
    },
    fetchEndpoint() {
      return projectEndpoint(
        {
          method: 'get',
          url: '',
          params: { expand: 'inbox_badge,inbox_remove,inbox_remove_after' },
          handler: data => {
            this.model = {
              inbox_badge: data.inbox_badge,
              inbox_remove: data.inbox_remove,
              inbox_remove_after: data.inbox_remove_after || {
                period: null,
                count: null
              }
            }
          }
        },
        this.projectId
      )
    },
    saveEndpoint() {
      return projectEndpoint(
        {
          method: 'patch',
          url: ''
        },
        this.projectId || this.$route.query.project_id
      )
    },
    rules() {
      return {
        inbox_badge: {
          required: true
        },
        inbox_remove: {
          required: true
        },
        inbox_remove_after: {
          required: false
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.remove-after-inputs {
  display: flex;
  margin-top: 8px;
  padding-left: 45px;
  .el-input-number {
    width: 120px;
    margin-right: 8px;
  }
  .el-select {
    width: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/settings/pages/InboxSettingsPage.vue